import type { Category } from './categories.js';
export type CategoryKind = 'expense' | 'income';
export const categoryKey = (s: string): string => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru').replace(/ё/g, 'е');
export function descendants(all: Category[], id: string): Set<string> {
  const found = new Set([id]);
  let changed = true;
  while (changed) { changed = false; for (const c of all) if (c.parentId && found.has(c.parentId) && !found.has(c.id)) { found.add(c.id); changed = true; } }
  return found;
}
export function categoryDepth(all: Category[], id: string): number {
  const seen = new Set<string>(); let depth = 0; let cursor: string | null = id;
  while (cursor) {
    if (seen.has(cursor)) return Infinity;
    seen.add(cursor); const c = all.find(c => c.id === cursor); if (!c) break;
    depth++; cursor = c.parentId;
  }
  return depth;
}
export function frequentCategories(all: Category[], facts: Array<{type: string; categoryId?: string; occurredAt?: string}>, kind: CategoryKind): Category[] {
  const count = new Map<string, {n: number; last: string}>();
  for (const t of facts) if (t.type === kind && t.categoryId) { const prev = count.get(t.categoryId); count.set(t.categoryId, {n: (prev?.n ?? 0) + 1, last: [prev?.last ?? '', t.occurredAt ?? ''].sort().at(-1)!}); }
  return all.filter(c => !c.archived && (c.kind ?? 'expense') === kind && count.has(c.id)).sort((a,b) => count.get(b.id)!.n - count.get(a.id)!.n || count.get(b.id)!.last.localeCompare(count.get(a.id)!.last) || a.name.localeCompare(b.name, 'ru')).slice(0,6);
}
/** Include ancestors only as context; a mixed parent must not move its children into the wrong part. */
export function categoryBranch(all: Category[], eligible: Set<string>): Set<string> {
  const visible = new Set(eligible);
  for (const id of eligible) { let p = all.find(c => c.id === id)?.parentId; const seen = new Set([id]);
    while (p && !seen.has(p)) { seen.add(p); visible.add(p); p = all.find(c => c.id === p)?.parentId; }
  }
  return visible;
}
